import { useEffect } from "react";

const SITE_URL = "https://sitecleanup.com.au";

function upsertMeta(attr, key, value) {
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
}

function upsertLink(rel, href) {
  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

export default function Seo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);

    const pathname = path || (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonical = `${SITE_URL}${pathname.startsWith("/") ? pathname : `/${pathname}`}`;

    upsertLink("canonical", canonical);
    if (title) {
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    upsertMeta("property", "og:url", canonical);
  }, [title, description, path]);
  return null;
}
